function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useCallback, useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';
import { Form, Field, FormSpy } from 'react-final-form';
import { get, isEmpty, isNil, uniqBy } from 'lodash';
import { SelectField, TextField } from '@unite-us/ui';
import validateCostAmount from '../../utils/validateCostAmount';
import validateUnitAmount from '../../utils/validateUnitAmount';
import InfoPanel from '@unite-us/client-utils/dist/InfoPanel/InfoPanel';
import { isRequired } from '@unite-us/client-utils/dist/utils/validations/validations';
import { feeSchedulePrograms as fspUtils } from '@unite-us/client-utils';
import moment from 'moment';
import { coreApi } from '../../api/config';
import { REFERRAL_PII_PHI_DESCRIPTION } from './constants';
import AuthorizationSubform from './AuthorizationSubform';
import ReferralProgramCard from './ReferralProgramCard';
import { FileUpload } from '../../common/form/FileUploadV2/FileUpload';
import { isUnlistedReferral, programIsOffPlatform, referralIsOON, referralIsGrouped, shouldShowNetworkSelect, filterNetworks, referralIsFunded } from './utils';
import fetchPrimaryWorkers from '../../actions/Referral/fetchPrimaryWorkers';
import { useDebounce } from '../../utils/useDebounce';
import { useFeatureFlag } from '../../utils/useFeatureFlag';
import { cannotMoveToReferralReasons } from '../../actions/Referral/cannotMoveToReferralReasons';
import ContactDocumentsSelector from '../../common/form/DocumentUploader/components/ContactDocumentsSelector';
import './ReferralBuilderForm.scss';
import { DateField } from '@unite-us/ui';
export function ReferralBuilderForm(_ref) {
  var _referral$case2;
  var crtb1239AdaptDraftReferralFlow = _ref.crtb1239AdaptDraftReferralFlow,
    currentEmployee = _ref.currentEmployee,
    currentProvider = _ref.currentProvider,
    hasDraftReferral = _ref.hasDraftReferral,
    navigateToAddResources = _ref.navigateToAddResources,
    referral = _ref.referral,
    referrals = _ref.referrals,
    index = _ref.index,
    referralSubtitle = _ref.referralSubtitle,
    onChange = _ref.onChange,
    unselected = _ref.unselected,
    removeProgram = _ref.removeProgram,
    onSetForm = _ref.onSetForm,
    moveToNewReferral = _ref.moveToNewReferral,
    moveToExistingReferral = _ref.moveToExistingReferral,
    updateAttachments = _ref.updateAttachments,
    source = _ref.source,
    networksUnlistedProgram = _ref.networksUnlistedProgram,
    _setReferralErrors = _ref.setReferralErrors,
    referralDescription = _ref.referralDescription,
    expandReferralsCard = _ref.expandReferralsCard;
  var service = referral.service,
    programs = referral.programs,
    primaryWorker = referral.primaryWorker,
    attachments = referral.attachments,
    attachableDocuments = referral.attachableDocuments;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    moveReferralMenus = _useState2[0],
    setMoveReferralMenus = _useState2[1];
  var _useState3 = useState(attachments),
    _useState4 = _slicedToArray(_useState3, 2),
    uploadedFiles = _useState4[0],
    setUploadedFiles = _useState4[1];
  var _useState5 = useState(primaryWorker ? [primaryWorker] : []),
    _useState6 = _slicedToArray(_useState5, 2),
    primaryWorkers = _useState6[0],
    setPrimaryWorkers = _useState6[1];
  var _useState7 = useState(referral),
    _useState8 = _slicedToArray(_useState7, 2),
    initialValues = _useState8[0],
    setInitialValues = _useState8[1];
  var _useState9 = useState(''),
    _useState10 = _slicedToArray(_useState9, 2),
    query = _useState10[0],
    setQuery = _useState10[1];
  var debouncedQuery = useDebounce(query, 500);
  var _useState11 = useState({
      filesTooBig: [],
      filesWrongType: [],
      filesTooBigAndWrongType: []
    }),
    _useState12 = _slicedToArray(_useState11, 2),
    rejectedFiles = _useState12[0],
    setRejectedFiles = _useState12[1];
  var isAuthorizationWorkflowEnabled = useFeatureFlag('pays3551AuthInSuperset', false);
  var isOON = referralIsOON(referral);
  var isGrouped = referralIsGrouped(referral);
  var isFunded = referralIsFunded(referral);
  var referralTitle = "Referral ".concat(index + 1, ": ").concat(service === null || service === void 0 ? void 0 : service.name).concat(isGrouped ? ', Grouped' : '').concat(isOON ? ', Off-Platform' : '').concat(isFunded ? ', Funded' : '');
  var crtb824AddOpenCloseDateOffPlatformCase = useFeatureFlag('crtb824AddOpenCloseDateOffPlatformCase', false);
  var crtb854ForwardingSuperset = useFeatureFlag('crtb854ForwardingSuperset', false);
  var showOpenedDate = isOON && crtb824AddOpenCloseDateOffPlatformCase;
  var today = moment().startOf('day').unix();

  // If all the programs in the referral are unlisted, show the user provider networks
  var networks = isUnlistedReferral(referral) ? networksUnlistedProgram : filterNetworks(referral);
  var showNetworkSelect = shouldShowNetworkSelect(networks, programs);
  var onProgramClick = function onProgramClick(id) {
    var programMenus = moveReferralMenus.map(function (p) {
      if (p.id === id) {
        p.menuIsOpen = !p.menuIsOpen;
      } else {
        p.menuIsOpen = false;
      }
      return p;
    });
    setMoveReferralMenus(programMenus);
  };
  var getPrimaryWorkers = useCallback(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var _yield$fetchPrimaryWo, primary_workers;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return fetchPrimaryWorkers({
            providerId: referral.sendingProvider.id,
            currentEmployee: currentEmployee,
            query: debouncedQuery
          });
        case 2:
          _yield$fetchPrimaryWo = _context.sent;
          primary_workers = _yield$fetchPrimaryWo.primary_workers;
          // if the query is empty, keep the queried employees and the current primary worker in select field's options array
          isEmpty(query) ? setPrimaryWorkers(uniqBy([].concat(_toConsumableArray(primaryWorkers), _toConsumableArray(primary_workers), [primaryWorker && primaryWorker]), 'id')) : setPrimaryWorkers(primary_workers);
        case 5:
        case "end":
          return _context.stop();
      }
    }, _callee);
  })), [currentEmployee, referral.sendingProvider.id, debouncedQuery]);
  var feeScheduleProgram = get(programs, '[0].fee_schedule_program');
  var initializePaymentFormValues = useCallback(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var _referral$case, _kase$data, _kaseData$service_aut, _kaseServiceAuthoriza, _clinicalModification, kase, kaseData, kaseServiceAuthorization, kaseServiceAuthorizationData, clinicalModification, clinicalModificationData, isUnitBased, amountRequestedInitialValue, paymentAuthFormValues;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!(referral.state === "draft" && feeScheduleProgram !== null && feeScheduleProgram !== void 0 && feeScheduleProgram.authorization_required)) {
            _context2.next = 17;
            break;
          }
          _context2.next = 3;
          return coreApi.findRecord('case', (_referral$case = referral.case) === null || _referral$case === void 0 ? void 0 : _referral$case.id);
        case 3:
          kase = _context2.sent;
          kaseData = kase === null || kase === void 0 || (_kase$data = kase.data) === null || _kase$data === void 0 ? void 0 : _kase$data.data;
          _context2.next = 7;
          return coreApi.findRecord('service_authorization', kaseData === null || kaseData === void 0 || (_kaseData$service_aut = kaseData.service_authorization) === null || _kaseData$service_aut === void 0 ? void 0 : _kaseData$service_aut.id);
        case 7:
          kaseServiceAuthorization = _context2.sent;
          kaseServiceAuthorizationData = kaseServiceAuthorization === null || kaseServiceAuthorization === void 0 || (_kaseServiceAuthoriza = kaseServiceAuthorization.data) === null || _kaseServiceAuthoriza === void 0 ? void 0 : _kaseServiceAuthoriza.data;
          _context2.next = 11;
          return coreApi.findRecord('clinical_modifications', kaseServiceAuthorizationData === null || kaseServiceAuthorizationData === void 0 ? void 0 : kaseServiceAuthorizationData.clinical_modifications[0].id);
        case 11:
          clinicalModification = _context2.sent;
          clinicalModificationData = clinicalModification === null || clinicalModification === void 0 || (_clinicalModification = clinicalModification.data) === null || _clinicalModification === void 0 ? void 0 : _clinicalModification.data;
          isUnitBased = !fspUtils.isCostPaymentType(feeScheduleProgram === null || feeScheduleProgram === void 0 ? void 0 : feeScheduleProgram.payment_type);
          amountRequestedInitialValue = isUnitBased ? kaseServiceAuthorizationData === null || kaseServiceAuthorizationData === void 0 ? void 0 : kaseServiceAuthorizationData.requested_unit_amount : (kaseServiceAuthorizationData === null || kaseServiceAuthorizationData === void 0 ? void 0 : kaseServiceAuthorizationData.requested_cents) / 100;
          paymentAuthFormValues = {
            amount_requested: amountRequestedInitialValue,
            service_end: moment(kaseServiceAuthorizationData === null || kaseServiceAuthorizationData === void 0 ? void 0 : kaseServiceAuthorizationData.requested_ends_at).unix(),
            service_start: moment(kaseServiceAuthorizationData === null || kaseServiceAuthorizationData === void 0 ? void 0 : kaseServiceAuthorizationData.requested_starts_at).unix(),
            icd10_code: !isEmpty(clinicalModificationData) ? {
              value: clinicalModificationData.code,
              id: clinicalModificationData.id
            } : {}
          };
          setInitialValues(function (previousValues) {
            var _previousValues$case;
            var initialValues = _objectSpread(_objectSpread({}, previousValues), {}, {
              case: _objectSpread(_objectSpread({}, previousValues.case), {}, {
                service_authorization: _objectSpread(_objectSpread({}, (_previousValues$case = previousValues.case) === null || _previousValues$case === void 0 ? void 0 : _previousValues$case.service_authorization), kaseServiceAuthorizationData)
              }),
              paymentAuthForm: _objectSpread(_objectSpread({}, previousValues.paymentAuthForm), paymentAuthFormValues)
            });
            if (crtb854ForwardingSuperset && referralDescription) {
              initialValues.description = referralDescription;
            }
            return initialValues;
          });
        case 17:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  })), [(_referral$case2 = referral.case) === null || _referral$case2 === void 0 ? void 0 : _referral$case2.id, referral.state, feeScheduleProgram === null || feeScheduleProgram === void 0 ? void 0 : feeScheduleProgram.payment_type, feeScheduleProgram === null || feeScheduleProgram === void 0 ? void 0 : feeScheduleProgram.authorization_required]);
  useEffect(function () {
    if (isOON) {
      getPrimaryWorkers();
    }
  }, [getPrimaryWorkers, isOON]);
  useEffect(function () {
    var programMenus = programs.map(function (p) {
      return {
        id: p.id,
        menuIsOpen: false
      };
    });
    setMoveReferralMenus(programMenus);
  }, [programs]);
  useEffect(function () {
    setInitialValues(_objectSpread(_objectSpread(_objectSpread({}, referral), isNil(referral.primaryWorker) && isOON ? {
      primaryWorker: primaryWorkers.find(function (worker) {
        return worker.id === currentEmployee.id;
      })
    } : null), crtb854ForwardingSuperset && referralDescription ? {
      referralDescription: referralDescription
    } : {}));
  }, [primaryWorkers, currentEmployee.id, index, isOON, referral, referralDescription]);
  useEffect(function () {
    if (!isEmpty(uploadedFiles)) {
      updateAttachments(uploadedFiles);
    }
  }, [uploadedFiles]);
  useEffect(function () {
    initializePaymentFormValues();
  }, [initializePaymentFormValues]);
  var validateOpenDate = function validateOpenDate(date) {
    try {
      var openDate = new Date(parseInt(date) * 1000);
      var maxDate = new Date(parseInt(today) * 1000);
      var minDate = new Date(moment().subtract(1, 'year').unix() * 1000);
      return isNaN(openDate.getTime()) || openDate.getTime() < minDate || openDate.getTime() > maxDate ? false : true;
    } catch (error) {
      console.error('Error validating open date', error);
      return false;
    }
  };
  return /*#__PURE__*/React.createElement(Form, {
    initialValues: initialValues,
    onSubmit: function onSubmit() {},
    validate: function validate(values) {
      var _errors$paymentAuthFo, _errors$paymentAuthFo2, _errors$paymentAuthFo3;
      var errors = {};
      if (!values.description || values.description.trim() === '') {
        errors.description = "Required";
      }
      ;
      if (showOpenedDate) {
        if (!values.opened_date) {
          errors.opened_date = "Required";
        }
        ;
        if (!validateOpenDate(values.opened_date)) {
          errors.opened_date = "Invalid date";
        }
        ;
      }
      if (isOON && !values.primaryWorker) {
        errors.primaryWorker = "Required";
      }
      ;
      if (showNetworkSelect && !values.network) {
        errors.network = "Required";
      }
      ;
      var paymentAuthForm = values === null || values === void 0 ? void 0 : values.paymentAuthForm;
      if (isAuthorizationWorkflowEnabled && feeScheduleProgram !== null && feeScheduleProgram !== void 0 && feeScheduleProgram.authorization_required) {
        var _paymentAuthForm$icd;
        errors.paymentAuthForm = {};
        var amountRequested = paymentAuthForm === null || paymentAuthForm === void 0 ? void 0 : paymentAuthForm.amount_requested;
        var serviceEnd = paymentAuthForm === null || paymentAuthForm === void 0 ? void 0 : paymentAuthForm.service_end;
        var icd10Code = paymentAuthForm === null || paymentAuthForm === void 0 || (_paymentAuthForm$icd = paymentAuthForm.icd10_code) === null || _paymentAuthForm$icd === void 0 ? void 0 : _paymentAuthForm$icd.value;
        var isCostBased = fspUtils.isCostPaymentType(feeScheduleProgram.payment_type);
        var cmCodeRequired = feeScheduleProgram.cm_code_required_on_authorization;
        errors.paymentAuthForm.amount_requested = isCostBased ? validateCostAmount(amountRequested) : validateUnitAmount(amountRequested);
        errors.paymentAuthForm.service_end = serviceEnd ? undefined : 'Required';
        errors.paymentAuthForm.icd10_code = icd10Code || !cmCodeRequired ? undefined : 'Required';
      } else {
        errors.paymentAuthForm = undefined;
      }
      var fieldErrors = {
        description: !!errors.description,
        opened_date: !!errors.opened_date,
        primary_worker: !!errors.primaryWorker,
        network: !!errors.network,
        service_end: !!(errors !== null && errors !== void 0 && (_errors$paymentAuthFo = errors.paymentAuthForm) !== null && _errors$paymentAuthFo !== void 0 && _errors$paymentAuthFo.service_end),
        amount_requested: !!(errors !== null && errors !== void 0 && (_errors$paymentAuthFo2 = errors.paymentAuthForm) !== null && _errors$paymentAuthFo2 !== void 0 && _errors$paymentAuthFo2.amount_requested),
        icd10_code: !!(errors !== null && errors !== void 0 && (_errors$paymentAuthFo3 = errors.paymentAuthForm) !== null && _errors$paymentAuthFo3 !== void 0 && _errors$paymentAuthFo3.icd10_code)
      };
      _setReferralErrors(index, fieldErrors);
      return errors;
    },
    mutators: {
      setFieldTouched: function setFieldTouched(args, state) {
        var _args3 = _slicedToArray(args, 2),
          name = _args3[0],
          touched = _args3[1];
        var field = state.fields[name];
        if (field) {
          field.touched = !!touched;
        }
      }
    },
    render: function render(_ref4) {
      var form = _ref4.form,
        values = _ref4.values;
      onSetForm && onSetForm(form);
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FormSpy, {
        subscription: {
          values: true
        },
        onChange: onChange
      }), /*#__PURE__*/React.createElement("div", {
        className: "bg-white border border-solid border-blue-border rounded md:w-4/6 lg:w-4/6",
        style: {
          marginLeft: expandReferralsCard && '-7.5rem'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "p-5 bg-dark-fill-blue"
      }, /*#__PURE__*/React.createElement("h2", {
        className: "text-xl font-black mb-1"
      }, referralTitle), /*#__PURE__*/React.createElement("h3", null, referralSubtitle)), /*#__PURE__*/React.createElement("div", {
        className: "p-5"
      }, isOON ? /*#__PURE__*/React.createElement("div", {
        className: "bg-alert-yellow border border-solid border-canary-yellow rounded p-3 mb-5"
      }, /*#__PURE__*/React.createElement("p", {
        className: "text-brand-blue"
      }, "You need to contact these programs directly because they're not receiving referrals on the Unite Us Platform.")) : null, /*#__PURE__*/React.createElement("h5", {
        className: "text-sm ui-form-field__label"
      }, "PROGRAMS"), programs.map(function (program) {
        var _moveReferralMenus$fi;
        var menuIsOpen = isEmpty(moveReferralMenus) ? false : moveReferralMenus === null || moveReferralMenus === void 0 || (_moveReferralMenus$fi = moveReferralMenus.find(function (p) {
          return p.id === program.id;
        })) === null || _moveReferralMenus$fi === void 0 ? void 0 : _moveReferralMenus$fi.menuIsOpen;
        var cannotMoveReasons = {};
        unselected.map(function (i) {
          return cannotMoveReasons[i] = cannotMoveToReferralReasons({
            program: program,
            referral: referral,
            referrals: referrals,
            index: i,
            currentProvider: currentProvider
          });
        });
        return /*#__PURE__*/React.createElement(ReferralProgramCard, {
          key: "referral-program-".concat(program === null || program === void 0 ? void 0 : program.id, "-card"),
          program: program,
          onClick: onProgramClick,
          isOON: programIsOffPlatform(program),
          menuIsOpen: menuIsOpen,
          unselected: unselected,
          referral: referral,
          removeProgram: removeProgram,
          moveToNewReferral: moveToNewReferral,
          moveToExistingReferral: moveToExistingReferral,
          cannotMoveReasons: cannotMoveReasons
        });
      }), /*#__PURE__*/React.createElement("p", {
        className: "text-center text-dark-grey my-10"
      }, "Click on the three-dot icon to edit referral groupings.", crtb1239AdaptDraftReferralFlow && hasDraftReferral ? /*#__PURE__*/React.createElement("div", null, "To add more programs, go to the ", /*#__PURE__*/React.createElement("a", {
        onClick: navigateToAddResources
      }, "Add Resources"), " page.") : null), showNetworkSelect ? /*#__PURE__*/React.createElement("div", {
        className: "mb-10"
      }, /*#__PURE__*/React.createElement(Field, {
        name: "network",
        required: true,
        key: "referral-".concat(index, "-network")
      }, function (params) {
        return /*#__PURE__*/React.createElement(SelectField, _extends({
          required: true,
          id: "network-selection",
          label: "Network Selection",
          placeholder: "Choose one...",
          options: networks,
          labelKey: "name",
          valueKey: "id",
          validations: isRequired
        }, params));
      })) : null, isAuthorizationWorkflowEnabled && (feeScheduleProgram === null || feeScheduleProgram === void 0 ? void 0 : feeScheduleProgram.authorization_required) && /*#__PURE__*/React.createElement(AuthorizationSubform, {
        feeScheduleProgram: feeScheduleProgram,
        formValues: values,
        setReferralErrors: function setReferralErrors(errors) {
          return _setReferralErrors(index, errors);
        }
      }), /*#__PURE__*/React.createElement(Field, {
        name: "description",
        required: true,
        key: "referral-".concat(index, "-description")
      }, function (params) {
        return /*#__PURE__*/React.createElement(TextField, _extends({
          afterLabelContent: /*#__PURE__*/React.createElement(InfoPanel, {
            className: "mb-4 mt-2",
            message: REFERRAL_PII_PHI_DESCRIPTION
          }),
          id: "referral-description",
          label: "Referral Description",
          placeholder: "Describe your client's current situation and reason for referral.",
          rows: 3,
          inline: false,
          validations: isRequired,
          required: true,
          style: source === 'emr' && get(params, 'meta.touched') && !get(params, 'meta.valid') ? {
            text: {
              'border-color': 'red'
            }
          } : {}
        }, params));
      }), showOpenedDate && /*#__PURE__*/React.createElement(Field, {
        name: "opened_date",
        required: true,
        key: "opened-".concat(index, "-date")
      }, function (params) {
        return /*#__PURE__*/React.createElement(DateField, _extends({
          field: "Open date",
          id: "opened-date",
          label: "Open date",
          validations: validateOpenDate(params.input.value),
          minDate: moment().subtract(1, 'year').unix(),
          maxDate: today,
          required: true,
          style: source === 'emr' && get(params, 'meta.touched') && !get(params, 'meta.valid') ? {
            text: {
              'border-color': 'red'
            }
          } : {}
        }, params));
      }), isOON ? /*#__PURE__*/React.createElement(Field, {
        name: "primaryWorker",
        required: true,
        key: "referral-".concat(index, "-primary-worker")
      }, function (params) {
        return /*#__PURE__*/React.createElement(SelectField, _extends({
          required: true,
          id: "primary-worker",
          label: "Primary Worker",
          placeholder: "Choose one...",
          loadOptions: function loadOptions(search) {
            return setQuery(search);
          },
          options: primaryWorkers,
          labelKey: "full_name",
          valueKey: "id",
          validations: isRequired
        }, params));
      }) : null, attachableDocuments && /*#__PURE__*/React.createElement("div", {
        className: "upload-documents"
      }, /*#__PURE__*/React.createElement("h5", null, "Documents"), /*#__PURE__*/React.createElement(ContactDocumentsSelector, {
        documentFields: attachableDocuments
      })), /*#__PURE__*/React.createElement(FileUpload, {
        rejectedFiles: rejectedFiles,
        setRejectedFiles: setRejectedFiles,
        setUploadedFiles: setUploadedFiles,
        uploadedFiles: attachments || []
      }))));
    }
  });
}
ReferralBuilderForm.propTypes = {
  currentEmployee: PropTypes.object.isRequired,
  currentProvider: PropTypes.object.isRequired,
  referral: PropTypes.shape({
    service: PropTypes.shape({
      name: PropTypes.string.isRequired
    }).isRequired,
    programs: PropTypes.array.isRequired
  }).isRequired,
  index: PropTypes.number.isRequired,
  referralSubtitle: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  unselected: PropTypes.array,
  removeProgram: PropTypes.func.isRequired,
  moveToNewReferral: PropTypes.func.isRequired,
  moveToExistingReferral: PropTypes.func.isRequired,
  onSetForm: PropTypes.func.isRequired,
  setReferralErrors: PropTypes.func.isRequired
};
ReferralBuilderForm.defaultProps = {
  referralSubtitle: '',
  unselected: []
};
export default ReferralBuilderForm;
//# sourceMappingURL=ReferralBuilderForm.js.map